export default __webpack_public_path__ + "static/bg-zappi-7771aa017723ed2d27b4e6f574dfe13f.webp";